import get from "../../../lib/requests";
import { CANCEL } from "redux-saga";
import axios from "axios";

export function requestGetUser(sku) {
	const ourRequest = axios.CancelToken.source();
	const promise = get(`api/user/verifylogin`, false, ourRequest.token);
	promise[CANCEL] = () => ourRequest.cancel();
	return promise;
}
